import React from 'react';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import { countries } from '@/data/countries';

interface CountrySelectProps {
    value?: string;
    onChange?: (value: string) => void;
    onValueChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
    value,
    onChange,
    onValueChange,
    placeholder = 'Select country...',
    className,
}) => {
    const selectedCountry = countries.find(country => country.code === value);
    const handleChange = onChange || onValueChange || (() => {});

    return (
        <Select value={value} onValueChange={handleChange}>
            <SelectTrigger className={className}>
                <SelectValue placeholder={placeholder}>
                    {selectedCountry ? (
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-medium">{selectedCountry.name}</span>
                            <span className="text-xs text-muted-foreground">
                                ({selectedCountry.phoneCode})
                            </span>
                        </div>
                    ) : (
                        placeholder
                    )}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {countries.map(country => (
                    <SelectItem key={country.code} value={country.code}>
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-medium">{country.name}</span>
                            <span className="text-xs text-muted-foreground">
                                ({country.phoneCode})
                            </span>
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
